<template>
  <!-- Modal -->
  <div
    class="modal fade"
    :id="modal_id"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">型式・型番を追加</h5>
        </div>
        <div class="modal-body">
          <div class="row g-3">
            <div class="col-12">
              <label for="code" class="form-label">型式・型番</label>
              <input
                v-model="inspection_call.code"
                type="text"
                class="form-control"
                :class="{ 'is-invalid': v$.inspection_call.code.$error }"
                id="code"
              />
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            閉じる
          </button>
          <button
            type="button"
            class="btn btn-dark"
            v-on:click.prevent="insert()"
          >
            追加
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { Modal } from 'bootstrap/dist/js/bootstrap.esm.min.js'
import store from '../store'

export default {
  name: 'InspectionCallForm',
  components: {},

  setup() {
    return { v$: useVuelidate() }
  },

  emits: ['insertCall'],
  props: {
    inspection_id: {
      type: Number,
    },
    inspection_type_id: {
      type: Number,
    },
  },

  data() {
    return {
      modal: null,
      inspection_call: {},
    }
  },
  computed: {
    modal_id: function () {
      let chars = 'abcdefghijklmnopqrstuvwxyz0123456789'
      let rand_str = ''
      for (let i = 0; i < 8; i++) {
        rand_str += chars.charAt(Math.floor(Math.random() * chars.length))
      }
      return 'form-modal-' + rand_str
    },
  },
  validations() {
    return {
      inspection_call: {
        code: { required },
      },
    }
  },

  mounted() {
    this.modal = new Modal(document.getElementById(this.modal_id))
    document
      .getElementById(this.modal_id)
      .addEventListener('hidden.bs.modal', this.clearForm)
  },
  beforeUnmount() {
    this.modal.hide()
  },

  methods: {
    show() {
      this.modal.show()
    },
    async insert() {
      const result = await this.v$.$validate()
      if (!result) {
        return
      }
      this.inspection_call.inspection_id = this.inspection_id
      this.inspection_call.inspection_type_id = this.inspection_type_id
      const data = await store.dispatch(
        'inspection_call/postOrPatch',
        this.inspection_call,
      )
      this.$emit('insertCall', data)
      this.modal.hide()
    },
    clearForm() {
      this.v$.$reset()
      this.inspection_call = {}
    },
  },
}
</script>
